import React from 'react'
import './ButtonEstancia.css'

import { connect } from 'react-redux'
import {
  setWidthButtonEstancia,
  getEstanciaButton
} from '../../modules/reducer'

import { Link } from 'react-router-dom'

import Measure from 'react-measure'

import { moving } from './ButtonsSlider'

const ButtonEstancia = ({
  index,
  path,
  active,
  nameButton,
  setWidthButtonEstancia
}) => {
  return (
    <Measure
      bounds
      onResize={contentRect => {
        setWidthButtonEstancia(index, contentRect.bounds.width)
      }}
    >
      {({ measureRef }) => (
        <div ref={measureRef} className="buttonEstancia">
          <Link
            draggable={false}
            onMouseDown={e => e.preventDefault()}
            className={active ? 'button active' : 'button'}
            to={path}
            onClick={e => {
              if (moving) {e.preventDefault()}
            }}
          >
            {nameButton}
          </Link>
        </div>
      )}
    </Measure>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  const getE = getEstanciaButton(ownProps.id)

  return ({ reducer }, ownProps) => {
    const estancia = getE(reducer)

    return {
      path: estancia.path,
      nameButton: estancia.nameButton,
      active: estancia.active
    }
  }
}

const mapDispatchToProps = { setWidthButtonEstancia }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonEstancia)
